﻿import { defineComponent, PropType } from 'vue';

import { Capacity } from "../../../services/capacity";

import { Product } from "../../../services/product";
import { product_detail } from '../../../objects/v1_3/product/product/product_detail';
import { product_detail_seller_information_month } from '../../../objects/v1_3/product/product/product_detail_seller_information_month';

import { week_day } from "../../../objects/front_end/calendar/week_day";

import { capacity } from "../../../objects/v1_3/product/capacity/capacity";

import calendar_month from "./calendar/calendar_month.vue";
import calendar_details from "./calendar/calendar_details.vue";

const Prod = new Product();
var queryDate = "" as string;

export default defineComponent({
    name: "calendar",
    components: {
        calendar_details,
        calendar_month
    },
    emits: [
        "monthChange",
        "dateChange"
    ],
    props: {
        tour_ids: { type: Array as PropType<string[]>, default: [] },
        selected_tour_id: String,
        trip_index: Number
    },
    data() {
        return {
            selected_month: new product_detail_seller_information_month(),
            loading_calendar: true as boolean,
            // months found without dates to show (see onMonthChange), "year-month" keys, left out of months()
            removed_months: [] as string[]
        }
    },
    methods: {
        // The tours' months are their priced months, which can run from long before the first departure (search_list can
        // list departures there too). A month whose capacities give no date to show (calendar_details.ts Has_Departures)
        // is removed from the months, and the next one in the same direction is shown instead (the other way at the end of
        // the list), until a month has dates. The last month left is never removed.
        async onMonthChange(month: product_detail_seller_information_month) {
            const direction: number = this.key(month) < this.key(this.selected_month) ? -1 : 1;

            this.loading_calendar = true;
            let current: product_detail_seller_information_month | undefined = month;
            while (current != undefined) {
                this.selected_month = current;
                await this.$refs.calendar_details.download_capacity(this.tour_ids, this.selected_tour_id, current.year, current.month);
                await this.onCalendarUpdate(this.selected_tour_id);

                if (this.$refs.calendar_details.Has_Departures()) {
                    break;
                }

                const months = this.months();
                const index = months.findIndex(m => m.year == current!.year && m.month == current!.month);
                const next: product_detail_seller_information_month | undefined = months[index + direction] ?? months[index - direction];
                if (next == undefined) {
                    break;
                }

                this.removed_months.push(current.year + "-" + current.month);
                current = next;
            }
            this.loading_calendar = false;

            this.$emit("monthChange", this.selected_month.year, this.selected_month.month);
        },
        // a sortable key (yyyymm) for the direction of a month change
        key(month: product_detail_seller_information_month): number {
            return (month?.year ?? 0) * 100 + (month?.month ?? 0);
        },
        async onCalendarUpdate(selected_tour_id : string | undefined) {
            if (queryDate == "") {
                queryDate = this.GetDepartureDateFromQuery();
                if (queryDate != "") {
                   let queryDateParts = queryDate.split("-");
                   this.selected_month.year = parseInt(queryDateParts[0]);
                   this.selected_month.month = parseInt(queryDateParts[1]);
                   await this.$refs.calendar_details.download_capacity(this.tour_ids, selected_tour_id,this.selected_month.year, this.selected_month.month);
                }     
           }
           await this.$refs.calendar_details.onCalendarUpdate(selected_tour_id);
        },
        // another tour opened: its months all start out in the list again
        Reset_Months() {
            this.removed_months = [];
        },
        onDateChange(weekday : week_day) {
            this.$emit("dateChange" , weekday);
        },
        months() {
            if (this.tour_ids?.length == 0) {
                return [];
            }

            let Mounts_Output: product_detail_seller_information_month[] = [];
            this.tour_ids.forEach((tour_id: string) => {
                Prod.Get_Details_Sync(tour_id, this.$store)?.seller_information?.months?.forEach(month => {
                    if (Mounts_Output.findIndex(f => f.year == month.year && f.month == month.month) == -1) {
                        Mounts_Output.push(month);
                    }
                });
            });

            Mounts_Output = Mounts_Output.sort((obj1, obj2) => {
                if (obj1.year < obj2.year || (obj1.year == obj2.year && obj1.month < obj2.month)) {
                    return -1;
                }

                if (obj1.year > obj2.year || (obj1.year == obj2.year && obj1.month > obj2.month)) {
                    return 1;
                }

                return 0;
            });

            if (Mounts_Output.length > 0 && this.selected_month?.year == undefined) {
                //this.month_selected(Mounts_Output[0]);
            }

            Mounts_Output = Mounts_Output.filter(month => !this.removed_months.includes(month.year + "-" + month.month));

            return Mounts_Output;
        },
        GetDepartureDateFromQuery() : string {
            let url = window.location.search.substring(1).replace("%20"," ");
            let params = url.split("&");
            let depDate = "";

            if(params.length > 0)
            {
                params.forEach((param: string) => {
                    if(param.includes("departuredate"))
                    {
                        depDate = param.split("=")[1];
                    }  
                });
            }

            return depDate;
        }

    },
    mounted() {
    }
})